import {
    refreshConversationMessages,
    requestConversationMessages, requestConversationMessagesFailure,
    requestConversationMessagesSuccess
} from "../conversation/actions";

import { getAuthorization } from '../../setupAmplify';
import { toast } from "react-toastify";

export const START_FILE_UPLOAD = 'START_FILE_UPLOAD';
export const startFileUpload = (key, file) => dispatch => {
    dispatch({
        type : START_FILE_UPLOAD,
        key: key,
        file: file
    });
}

export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const updateUploadProgress = (key, file) => dispatch => {
    dispatch({
        type : UPLOAD_PROGRESS,
        key: key,
        file: file
    });
}

export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const uploadSuccess = (key, file, storedFile) => dispatch => {
    dispatch({
        type : UPLOAD_SUCCESS,
        key: key,
        file: file,
        storedFile: storedFile
    });
}

export const UPLOAD_FAILURE = 'UPLOAD_FAILURE';
export const uploadFailure = (key, file, errorMsg) => dispatch => {
    dispatch({
        type : UPLOAD_FAILURE,
        key: key,
        file: file,
        errorMsg: errorMsg
    });
}

export const CLEAR_UPLOADS = 'CLEAR_UPLOADS';
export const clearUploads = (key) => dispatch => {
    dispatch({
        type : CLEAR_UPLOADS,
        key: key
    });
}

export const CLEAR_UPLOAD = 'CLEAR_UPLOAD';
export const clearUpload = (key, file) => dispatch => {
    dispatch({
        type : CLEAR_UPLOAD,
        key: key,
        file: file
    });
}

export function uploadFile(key, file) {
    return async function(dispatch) {
        dispatch(startFileUpload(key, file));

        try {
            const token = await getAuthorization();
            const formData = new FormData();
            formData.append("file", file, file.name);

            const response = await fetch(
                window.__RUNTIME_CONFIG__.API_HOST + "/api/v1/files/upload",
                {
                    method: "POST",
                    headers: { "Authorization": token },
                    body: formData
                }
            );

            if (!response.ok) {
                toast("Could not upload file", { position: "top-center", type: "error" });
                dispatch(uploadFailure(key, file, `Upload failed with status ${response.status}`));
                return;
            }

            const res = await response.json();

            if (res.error) {
                toast("Could not upload file", { position: "top-center", type: "error" });
                dispatch(uploadFailure(key, file, res.error));
            } else {
                dispatch(uploadSuccess(key, file, res.file));
            }
        } catch (error) {
            toast("Could not upload file", { position: "top-center", type: "error" });
            dispatch(uploadFailure(key, file, error.message || "Upload failed"));
        }
    }
}